import Vue from 'vue'
import HeaderModals from '@/components/modals/header-modals.vue'

export default function modalsInit({ pinia, router }) {
  const modalApp = new Vue({
    name: 'ModalsApp',
    components: { HeaderModals },
    pinia,
    router,
    render(h) {
      return <HeaderModals />
    },
  })

  // mount and replace div in id="header"
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header')
    const modalElement = document.createElement('div')
    header.parentNode.insertBefore(modalElement, header)
    modalApp.$mount(modalElement)
  })
}
